import type { SuccessLayoutProps } from "./SuccessLayoutProps";
import classes from "./SuccessLayout.module.scss";
import { Container } from "@/components/ui/Container";
import { clsx } from "clsx";

export function SuccessLayout(props: SuccessLayoutProps) {
  const { className, video, header, content } = props;

  return (
    <>
      <div className={clsx(classes.wrapper, className)}>
        <Container maxWidth="lg">
          <div className={classes.layout}>
            <div className={classes.contentTop}>{header}</div>

            <div className={classes.videoContainer}>
              <div className={classes.video}>{video}</div>
            </div>

            <div className={classes.contentBottom}>{content}</div>
          </div>
        </Container>
      </div>
    </>
  );
}
